import { CommonModule, Location } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { getClient } from '@monorepo-channels/channels/domain'
import { isMobile, MenuOpened } from '@monorepo-channels/shared/util-helpers'
import { Store } from '@ngrx/store'
import { NgxMaskPipe } from 'ngx-mask'

@Component({
	selector: 'feature-porto-bank-profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.scss'],
	imports: [CommonModule, MatButtonModule, MatIconModule, NgxMaskPipe],
	standalone: true,
})
export class ProfileComponent {
	private store = inject(Store)
	public client$ = this.store.select(getClient)
	public location = inject(Location)
	public menuOpened = inject(MenuOpened)
	isMobile = isMobile()
}
